import React, { useState, useContext, Fragment } from 'react';
import { TrainListItem } from './TrainListItem';
import RouteInfoContext from '../RouteInfoContext';
import CovidEpassTrains from './CovidEpassTrains';
import { WeeklyTrainInfo } from '../../types';
import { isMobile } from '../../../utils/commonUtils';
import { trackClickEventProp54 } from '../../../utils/omnitureUtils';
import AdWrapper from '../../components/AdWrapper';
import BookABus from '../../components/BookABus/BookABus';
import { AD_PAGES } from '../../../utils/adsUtils';
import { SEO_ROUTE_PAGE, SHOW_ADS_ON_ROUTE_TRAIN_LISTIN_AT_INDEX } from '../../../utils/RailsSEOConstants';
import { trackClickEventProp61 } from '../../../utils/omnitureUtils';
import Spotlight from '../../Slider/Spotlight/Spotlight';
import SlideUpModal from '../../SlideUpModal/SlideUpModal';
import BusListing from '../../BusListing/BusListing';

const isSsr = () => typeof window === 'undefined';

export default function TrainBetweenStationsSection() {
  const [showFullTrains, setShowFullTrains] = useState(isSsr());
  const [modalOpen, setModalOpen] = useState(false);
  const trainsData = useContext(RouteInfoContext);
  const isTrainlengthLessThanIndex =
    trainsData?.trainsBetweenStations?.length < SHOW_ADS_ON_ROUTE_TRAIN_LISTIN_AT_INDEX[0];
  const [numberOfTrainsLessThanAdsIndex] = useState(isTrainlengthLessThanIndex);

  const source = trainsData?.fromCity;
  const destination = trainsData?.toCity;
  const hasBusData =
    trainsData?.busSeoRoutes?.busGroups?.find((busGroup) => busGroup.groupName === 'Private Buses')?.buses?.length > 0;

  const fromStations = new Set();
  const toStations = new Set();
  const trainsCount = trainsData.trainsBetweenStations.length;
  trainsData.trainsBetweenStations.forEach((trainNumber) => {
    const { fromStnCode, toStnCode } = trainsData.trainsMap[trainNumber];
    fromStations.add(fromStnCode);
    toStations.add(toStnCode);
  });
  const fromStationsStr = [...fromStations].join(', ');
  const toStationsStr = [...toStations].join(', ');

  const covidFromStations = new Set();
  const covidToStations = new Set();
  const covidTrainsCount = trainsData.weeklyCovidTrainList.list.length;
  trainsData.weeklyCovidTrainList.list.forEach(({ fromStnCode, toStnCode }) => {
    covidFromStations.add(fromStnCode);
    covidToStations.add(toStnCode);
  });

  const covidFromStationsStr = [...covidFromStations].join(', ');
  const covidToStationsStr = [...covidToStations].join(', ');

  const festiveFromStations = new Set();
  const festiveToStations = new Set();
  const festiveTrainsCount = trainsData.weeklyFestiveTrainList.list.length;
  trainsData.weeklyFestiveTrainList.list.forEach(({ fromStnCode, toStnCode }) => {
    festiveFromStations.add(fromStnCode);
    festiveToStations.add(toStnCode);
  });

  const festiveFromStationsStr = [...festiveFromStations].join(', ');
  const festiveToStationsStr = [...festiveToStations].join(', ');

  let stationUrlMap = trainsData.source.obj.railwayStations.reduce(
    (stationUrlMap, station) => ({
      ...stationUrlMap,
      [station.code]: station.stationPageUrl
    }),
    {}
  );

  stationUrlMap = trainsData.destination.obj.railwayStations.reduce(
    (stationUrlMap, station) => ({
      ...stationUrlMap,
      [station.code]: station.stationPageUrl
    }),
    stationUrlMap
  );

  function displayAdsConditionally(index) {
    if (
      trainsData?.partialRouteImplementationConstants?.showAddForRouteTemplate &&
      SHOW_ADS_ON_ROUTE_TRAIN_LISTIN_AT_INDEX.includes(index + 1)
    ) {
      return getAds();
    } else return null;
  }

  function displayAdsForTemplateListing() {
    if (!isMobile() && trainsData?.partialRouteImplementationConstants?.showAddForRouteTemplate) {
      if (trainsCount > 3) {
        return (
          <div className="makeFlex perfectCenter appendBottom10 appendTop10">
            <AdWrapper adsPageName={AD_PAGES.TRAINS_SEO_ROUTE_TEMPLATE_LISTING_1.adsPageName} />
          </div>
        );
      }
    }
  }

  function getAdsAtBottom() {
    if (trainsData?.partialRouteImplementationConstants?.showAddForRouteTemplate && numberOfTrainsLessThanAdsIndex) {
      return getAds();
    } else return null;
  }

  function getAds() {
    return (
      <div className={`makeFlex perfectCenter appendBottom20`}>
        {isMobile() && (
          <AdWrapper adsPageName={AD_PAGES.RAIL_TRAINS_SEO_ROUTE_TEMPLATE_MOBILE_MIDDLE_TOP_FOLD.adsPageName} />
        )}
      </div>
    );
  }

  return (
    <section>
      {modalOpen && (
        <SlideUpModal
          onClose={() => {
            trackClickEventProp54('trains_seo_route_cp_sidebar_closed');
            setModalOpen(false);
          }}
          hasTransparentBackdrop={true}
          isModalOpen={modalOpen}
        >
          <BusListing
            onClose={() => {
              trackClickEventProp54('trains_seo_route_cp_sidebar_closed');
              setModalOpen(false);
            }}
          />
        </SlideUpModal>
      )}
      <div style={{ height: '93px' }} className={`makeFlex perfectCenter`}>
        <AdWrapper adsPageName={AD_PAGES.ROUTE_INFO_PAGE.adsPageName} />
      </div>

      {trainsCount > 0 && (
        <>
          <div className={`heading appendTop15 appendBottom15`}>
            <div className="navigationUrl">
              <h1 style={{ fontSize: '22.5px', lineHeight: '20px' }} className="">
                {trainsData.weeklyTrainList.title}
              </h1>
              {!isMobile() && (
                <p style={{ display: 'none' }} className="url desktopShow">
                  <a
                    href={trainsData.alternatePageUrlInfo.pageUrl}
                    onClick={() => trackClickEventProp61(SEO_ROUTE_PAGE, 'rail_seo_route_switch_hindi')}
                  >
                    {trainsData.alternatePageUrlInfo.title}
                  </a>
                </p>
              )}
            </div>
            <p className="subHeading">
              {`${trainsCount} train${trainsCount > 0 ? 's' : ''} found from ${fromStationsStr} to ${toStationsStr}`}
            </p>
          </div>
          <ul className="makeFlex column">
            {trainsData.trainsBetweenStations
              .filter((_, index) => showFullTrains || index < 10)
              .map((trainNumber, id) => {
                const train: WeeklyTrainInfo = trainsData.trainsMap[trainNumber];
                if (id === 2) {
                  return (
                    <Fragment>
                      <div>
                        {isMobile() && hasBusData && (
                          <Fragment>
                            <Spotlight
                              openModal={() => {
                                trackClickEventProp54('trains_seo_route_cp_cta_clicked');
                                setModalOpen(true);
                              }}
                            />
                          </Fragment>
                        )}
                      </div>
                      {!isMobile() && hasBusData && <BookABus source={source} destination={destination} />}
                      <TrainListItem
                        key={trainNumber}
                        train={train}
                        trainsData={trainsData}
                        onClick={trainsData.onTrainExtraSectionClicked}
                        stationUrlMap={stationUrlMap}
                        pageName={SEO_ROUTE_PAGE}
                      />
                      {displayAdsForTemplateListing()}
                    </Fragment>
                  );
                }
                return (
                  <>
                    {displayAdsConditionally(id)}
                    <TrainListItem
                      key={trainNumber}
                      train={train}
                      trainsData={trainsData}
                      onClick={trainsData.onTrainExtraSectionClicked}
                      stationUrlMap={stationUrlMap}
                      pageName={SEO_ROUTE_PAGE}
                    />
                  </>
                );
              })}
          </ul>
          {getAdsAtBottom()}
          <div className="showMoreTrains">
            {trainsData.trainsBetweenStations.length > 10 && (
              <text
                role="button"
                onClick={() => {
                  trackClickEventProp61(SEO_ROUTE_PAGE, 'rail_seo_route_trainroutecard_showmore_clicked');
                  setShowFullTrains(!showFullTrains);
                }}
              >
                {showFullTrains ? trainsData.miscellaneous['SHOW LESS'] : trainsData.miscellaneous['SHOW MORE']}
              </text>
            )}
          </div>
        </>
      )}
      {trainsCount > 0 && trainsData?.partialRouteImplementationConstants?.showAddForRouteTemplate && (
        <div className="makeFlex perfectCenter">
          <AdWrapper adsPageName={AD_PAGES.RAIL_TRAINS_SEO_ROUTE_TEMPLATE.adsPageName} />
        </div>
      )}
      {festiveTrainsCount > 0 && (
        <>
          <div className="heading appendTop15 appendBottom15">
            {trainsCount > 0 ? (
              <h2 style={{ fontSize: '22.5px', lineHeight: '20px' }} className="">
                {trainsData.weeklyFestiveTrainList.title}
              </h2>
            ) : (
              <h1 className="">{trainsData.template.h1_title}</h1>
            )}
            <p className="subHeading">
              {`${festiveTrainsCount} festive special train${
                festiveTrainsCount > 1 ? 's' : ''
              }  found from ${festiveFromStationsStr} to ${festiveToStationsStr}`}
            </p>
            {
              <div className="url appendTop10 mobileShow">
                <a href={trainsData.alternatePageUrlInfo.pageUrl}>{trainsData.alternatePageUrlInfo.title}</a>
              </div>
            }
          </div>
          <CovidEpassTrains
            trainsList={trainsData.weeklyFestiveTrainList.list}
            onClicked={trainsData.onTrainExtraSectionClicked}
            pageName={SEO_ROUTE_PAGE}
          />
          <br />
        </>
      )}
      {covidTrainsCount > 0 && (
        <>
          <div className={`heading appendTop15 appendBottom15`}>
            {trainsCount > 0 || festiveTrainsCount > 0 ? (
              <h2 style={{ fontSize: '22.5px', lineHeight: '20px' }} className="">
                {trainsData.weeklyCovidTrainList.title}
              </h2>
            ) : (
              <h1 className="">{trainsData.template.h1_title}</h1>
            )}
            <p className="subHeading">
              {`${covidTrainsCount} COVID special train${
                covidTrainsCount > 1 ? 's' : ''
              } found from ${covidFromStationsStr} to ${covidToStationsStr}`}
            </p>
          </div>
          <CovidEpassTrains
            trainsList={trainsData.weeklyCovidTrainList.list}
            onClicked={trainsData.onTrainExtraSectionClicked}
            pageName={SEO_ROUTE_PAGE}
          />
          <br />
        </>
      )}
    </section>
  );
}
